// Amostra de cor para o seletor de família (2026-10-19): nome da cor em
// português -> cor CSS. Nome desconhecido devolve null e o botão fica só com
// o texto, como antes. Puro, testado em tests/colorSwatches.test.mjs.

const BASE_COLORS: Record<string, string> = {
  amarelo: "#f5c400",
  azul: "#1d4ed8",
  bege: "#e8d8b8",
  branco: "#ffffff",
  bronze: "linear-gradient(135deg,#a36a2b,#e0a96d,#7a4a1c)",
  castanho: "#6b3e1f",
  cinza: "#8a8f98",
  cobre: "linear-gradient(135deg,#9a4f22,#e39a6a,#7a3a16)",
  creme: "#f3e9d2",
  dourado: "linear-gradient(135deg,#b8860b,#f4d675,#9a7009)",
  grafite: "#3f4247",
  incolor: "linear-gradient(135deg,#ffffff 45%,#dbe4ee 50%,#ffffff 55%)",
  laranja: "#f97316",
  lilas: "#c4a3e0",
  marfim: "#f6efdc",
  marrom: "#7a4a24",
  ocre: "#c8892b",
  ouro: "linear-gradient(135deg,#b8860b,#f4d675,#9a7009)",
  prata: "linear-gradient(135deg,#9ca3af,#f3f4f6,#7b818a)",
  preto: "#111111",
  rosa: "#f472b6",
  roxo: "#7e22ce",
  transparente: "linear-gradient(135deg,#ffffff 45%,#dbe4ee 50%,#ffffff 55%)",
  verde: "#16a34a",
  vermelho: "#dc2626",
  violeta: "#7c3aed",
  vinho: "#7f1d1d",
};

const SHADES: Record<string, Record<string, string>> = {
  azul: { claro: "#60a5fa", escuro: "#1e3a8a", marinho: "#1e2a5a", celeste: "#7dd3fc", turquesa: "#14b8a6" },
  verde: { claro: "#86efac", escuro: "#14532d", limao: "#a3e635", bandeira: "#15803d", musgo: "#4d5d2a", agua: "#5eead4" },
  cinza: { claro: "#cbd5e1", escuro: "#4b5563", chumbo: "#4b5057" },
  amarelo: { claro: "#fde68a", ouro: "#eab308", canario: "#fde047" },
  vermelho: { escuro: "#991b1b", ferrari: "#e10600" },
  marrom: { claro: "#a87b51", escuro: "#4a2c14", cafe: "#4b2e1a", tabaco: "#6b4423" },
  rosa: { claro: "#fbcfe8", choque: "#ec4899" },
};

function normalize(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9 ]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/** Atributo da família é de cor? (rótulo ou chave "Cor", "Cores", "pa_cor"...) */
export function isColorAttribute(attribute: { taxonomy: string; label: string }): boolean {
  const label = normalize(attribute.label);
  const key = normalize(attribute.taxonomy.replace(/^pa_/, "").replace(/[-_]/g, " "));
  return /^cor(es)?\b/.test(label) || /^cor(es)?\b/.test(key);
}

/** Cor CSS (hex ou gradiente) para o nome da cor; null se não reconhecer. */
export function colorSwatchFor(name: string): string | null {
  const words = normalize(name).split(" ").filter(Boolean);
  for (let index = 0; index < words.length; index += 1) {
    const base = BASE_COLORS[words[index]];
    if (!base) continue;
    const shades = SHADES[words[index]];
    const modifier = shades ? words.slice(index + 1).find((word) => shades[word]) : undefined;
    return modifier && shades ? shades[modifier] : base;
  }
  return null;
}
